import React, { SyntheticEvent, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    Card,
    CardActions,
    CardHeader,
    CardContent,
    Modal,
    Button,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@material-ui/core";
import ViewDay from "@material-ui/icons/ViewDay";
import CheckCircle from "@material-ui/icons/CheckCircle";
import styled from "styled-components";

const StyledCard = styled(Card)`
    && {
        transform: translate(-50%, -50%);
        overflow: visible;
        left: 50%;
        top: 50%;
        position: absolute;
    }
`;

interface IStyledListItem {
    selected: boolean;
}
const StyledListItem = styled(ListItem)<IStyledListItem>`
    && {
        background-color: rgba(
            0,
            0,
            0,
            ${(props) => (props.selected ? 0.08 : 0)}
        );
        padding-top: 2px;
        padding-bottom: 2px;
    }
    padding-top: 4px;
    padding-bottom: 4px;
`;
interface IAddTrackModalProps {
    nameLodashPath: string[];
    open: boolean;
    onClose(event: SyntheticEvent<{}, Event>): void;
    selectSubjectsForAddMenu(state: any): any;
    setChosenSubjects(subjects: { name: string; key: string }[]): any;
    name: string;
}

interface ISelectedIndices {
    [index: number]: boolean;
}
export const AddSubjectModal = (props: IAddTrackModalProps) => {
    const dispatch = useDispatch();
    const subjects = useSelector(
        props.selectSubjectsForAddMenu(props.nameLodashPath)
    ) as { name: string; key: string }[];

    const [selectedIndices, setSelectedIndex] = React.useState(
        {} as ISelectedIndices
    );

    useEffect(() => {
        setSelectedIndex({});
    }, [props.open]);
    function handleListItemClick(
        event: React.MouseEvent<HTMLElement, MouseEvent>,
        index: number
    ) {
        if (typeof selectedIndices[index] === "undefined") {
            selectedIndices[index] = true;
        } else {
            selectedIndices[index] = !selectedIndices[index];
        }
        setSelectedIndex({ ...selectedIndices });
    }

    return (
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={props.open}
            onClose={props.onClose}
        >
            <StyledCard>
                <CardHeader title={`Add ${props.name}`} />
                <CardContent>
                    <List component="nav" aria-label="Main mailbox folders">
                        {subjects.map(({ key, name }, i) => {
                            const selected = selectedIndices[i] === true;

                            return (
                                <StyledListItem
                                    button
                                    selected={selected}
                                    onClick={(event) =>
                                        handleListItemClick(event, i)
                                    }
                                    key={i}
                                >
                                    <ListItemIcon>
                                        <ViewDay />
                                    </ListItemIcon>
                                    <ListItemText primary={`${name}`} />
                                    {selected && (
                                        <ListItemIcon>
                                            <CheckCircle />
                                        </ListItemIcon>
                                    )}
                                </StyledListItem>
                            );
                        })}
                    </List>
                </CardContent>
                <CardActions>
                    <Button
                        href="#text-buttons"
                        onClick={(e) => {
                            const keys = Object.keys(selectedIndices)
                                .filter(
                                    (e) => selectedIndices[parseInt(e)] === true
                                )
                                .map((e) => subjects[parseInt(e)]);

                            dispatch(props.setChosenSubjects(keys));

                            props.onClose(e);
                        }}
                    >
                        Add
                    </Button>
                    <Button onClick={props.onClose}>Cancel</Button>
                </CardActions>
            </StyledCard>
        </Modal>
    );
};